import { Component, OnInit } from '@angular/core';
import {LoadingService} from '../../Services/loading.service';

@Component({
  selector: 'pm-loader-component',
  templateUrl: './loader-component.component.html',
  styleUrls: ['./loader-component.component.css']
})
export class LoaderComponentComponent implements OnInit {
  loading = false;

  constructor(private loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadingService.loading$.subscribe(
        loading => this.loading = loading
    );
  }

}
